import { Language, TemplateSubType, TemplateType } from '../../../types/dto-app';

export const leaseContractRetractedTemplates = [
  {
    id: '-107001',
    language: Language.EN,
    subject: 'Your invitation to sign your lease contract has been retracted',
    type: TemplateType.MAIL,
    subType: TemplateSubType.LEASE_CONTRACT_RETRACTED,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
        <p>Dear {{listAllTenants lease}},</p>
        <p></p>
        <p>Concerns: signature invitation retraction regarding the lease located at <strong>{{getLeaseMainAddress lease}}</strong>.</p>
        <p></p>
        <p>For your information, the issuer has retracted the current version of the contract.</p>
        <p>It is likely that your contract may need some amendments. If so, you'll receive a new invitation to sign shortly.</p>
        <p></p>
        <p>Kind regards,</p>
        <p></p>
        <p>{{accountSignature client}}</p>
        `,
  },
  {
    id: '-107002',
    language: Language.FR,
    subject: 'Votre invitation à signer le contrat de bail a été rétractée',
    type: TemplateType.MAIL,
    subType: TemplateSubType.LEASE_CONTRACT_RETRACTED,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
        <p>Cher/Chère {{listAllTenants lease}},</p>
        <p></p>
        <p>Concerne: retrait de l'invitation à signer le bail sis <strong>{{getLeaseMainAddress lease}}</strong>.</p>
        <p></p>
        <p>Pour votre information, l'emetteur à révoqué votre invitation à signer le contrat.</p>
        <p>Il est probable que votre contrat doive subir quelques modifications. Le cas échéant, une nouvelle invitation à signer vous parviendra sous peu.</p>
        <p></p>
        <p>Bien à vous,</p>
        <p></p>
        <p>{{accountSignature client}}</p>`,
  },
  {
    id: '-107003',
    language: Language.NL,
    subject: 'Uw uitnodiging om het huurcontract te ondertekenen is ingetrokken',
    type: TemplateType.MAIL,
    subType: TemplateSubType.LEASE_CONTRACT_RETRACTED,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
        <p>Geachte {{listAllTenants lease}},</p>
        <p></p>
        <p>Betreffende: intrekking van de uitnodiging om uw huurcontract gelegen te <strong>{{getLeaseMainAddress lease}}</strong> te ondertekenen.</p>
        <p></p>
        <p>Ter informatie, de uitgever heeft uw uitnodiging om het huurcontract te ondertekenen ingetrokken.</p>
        <p>Het is waarschijnlijk dat uw contract zal moeten worden gewijzigd. Zo ja, dan zal u binnenkort en nieuwe uitnodiging tot ondertekening worden toekestuurd.</p>
        <p></p>
        <p>Met vriendelijke groeten,</p>
        <p></p>
        <p>{{accountSignature client}}</p>
        `,
  },
  {
    id: '-107004',
    language: Language.DE,
    subject: 'Ihre Einladung zur Unterzeichnung des Mietvertrags wurde zurückgezogen',
    type: TemplateType.MAIL,
    subType: TemplateSubType.LEASE_CONTRACT_RETRACTED,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
        <p>Liebe/r {{listAllTenants lease}},</p>
        <p></p>
        <p>Betreff: Zurückziehung der Unterzeichnungseinladung bezüglich des Mietvertrags in <strong>{{getLeaseMainAddress lease}}</strong>.</p>
        <p></p>
        <p>Zu Ihrer Information: Der Aussteller hat die aktuelle Version des Vertrags zurückgezogen.</p>
        <p>Es ist wahrscheinlich, dass Ihr Vertrag einige Änderungen benötigt. Falls ja, erhalten Sie in Kürze eine neue Einladung zur Unterzeichnung.</p>
        <p></p>
        <p>Mit freundlichen Grüßen,</p>
        <p></p>
        <p>{{accountSignature client}}</p>
        `,
  },
];
